import React from 'react';

const paths = {
  drop: <path d="M12 2.5c-2.6 3.6-7 8-7 12a7 7 0 0 0 14 0c0-4-4.4-8.4-7-12Z" />,
  plus: <path d="M12 5v14M5 12h14" />,
  chat: <path d="M20 11.5a8 8 0 0 1-8 8H5l-3 2v-10a9 9 0 0 1 18 0Z" />,
  arrow: <path d="M12 19V5m-6 6 6-6 6 6" />,
  external: <path d="M7 17 17 7M7 7h10v10" />,
  menu: <path d="M4 7h16M4 12h12M4 17h16" />,
  close: <path d="m6 6 12 12M6 18 18 6" />,
  trash: <><path d="M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14M10 11v6M14 11v6" /></>,
  book: <path d="M12 5c-3-2-6-2-9-1v15c3-1 6-1 9 1m0-15c3-2 6-2 9-1v15c-3-1-6-1-9 1V5Z" />,
};

export default function ChatIcon({ name, className = '' }) {
  return <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name]}</svg>;
}
